module.exports = __webpack_public_path__ + "img/noti-cross.png?8b70ae6456c1b4edf2f2cd2a32add807";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/noti-cross.png
// module id = 263
// module chunks = 0